/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KnowledgeBaseSelection
 */
export interface KnowledgeBaseSelection {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseSelection
     */
    knowledgeBaseId: string;
    /**
     * 
     * @type {boolean}
     * @memberof KnowledgeBaseSelection
     */
    isSpoKnowledgeBase: boolean;
}

/**
 * Check if a given object implements the KnowledgeBaseSelection interface.
 */
export function instanceOfKnowledgeBaseSelection(value: object): value is KnowledgeBaseSelection {
    if (!('knowledgeBaseId' in value) || value['knowledgeBaseId'] === undefined) return false;
    if (!('isSpoKnowledgeBase' in value) || value['isSpoKnowledgeBase'] === undefined) return false;
    return true;
}

export function KnowledgeBaseSelectionFromJSON(json: any): KnowledgeBaseSelection {
    return KnowledgeBaseSelectionFromJSONTyped(json, false);
}

export function KnowledgeBaseSelectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): KnowledgeBaseSelection {
    if (json == null) {
        return json;
    }
    return {
        
        'knowledgeBaseId': json['knowledgeBaseId'],
        'isSpoKnowledgeBase': json['isSpoKnowledgeBase'],
    };
}

export function KnowledgeBaseSelectionToJSON(json: any): KnowledgeBaseSelection {
    return KnowledgeBaseSelectionToJSONTyped(json, false);
}

export function KnowledgeBaseSelectionToJSONTyped(value?: KnowledgeBaseSelection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'knowledgeBaseId': value['knowledgeBaseId'],
        'isSpoKnowledgeBase': value['isSpoKnowledgeBase'],
    };
}

